var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-list__selectable"},[_vm._t("top"),_c('ul',{staticClass:"app-list"},_vm._l((_vm.selectableList),function(item,index){return _c('list-item',{key:item.ID,attrs:{"item":item,"index":index},on:{"click:select":_vm.selectItem},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var select = ref.select;
var selected = ref.selected;
return [_vm._t("item",null,{"item":item,"index":index,"select":select,"selected":selected})]}}],null,true)})}),1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }